import { useState } from 'react';
import type { InputHTMLAttributes } from 'react';
import { AUTH_INPUT } from './authStyles';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'className'>;

export default function AuthPasswordInput(props: Props) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input {...props} type={visible ? 'text' : 'password'} className={`${AUTH_INPUT} pr-12`} />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        aria-pressed={visible}
        aria-label={visible ? 'Hide password' : 'Show password'}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-neutral-400 hover:text-neutral-700 cursor-pointer"
      >
        <i className={visible ? 'ri-eye-line text-lg' : 'ri-eye-off-line text-lg'} aria-hidden="true" />
      </button>
    </div>
  );
}
